import { HttpParams } from '@angular/common/http';
import { cloneDeep } from 'lodash';
import { environment } from '@fluxonos/environments/environment';
import { IApiEndpoint } from '@fluxonos/features/shared/interfaces/api-endpoint.interface';
import { SearchRequestDto } from '@fluxonos/fluxonos-dto';
import { instanceToPlain } from 'class-transformer';
import { NgFluxonosUtils } from '@fluxonos/features/shared/ng-fluxonos.utils';

export abstract class BaseService {
  protected getEndpoint(endpoint: object, ...params: any[]): IApiEndpoint {
    const findPath = (obj: any, valueToFind: any, path: string[] = []): string[] | null => {
      if (obj === valueToFind) return path;
      if (typeof obj === 'object' && obj !== null) {
        for (const [key, value] of Object.entries(obj)) {
          const result = findPath(value, valueToFind, [...path, key]);
          if (result) {
            return cloneDeep(result);
          }
        }
      }
      return null;
    };

    const path = findPath(environment, endpoint);
    if (!path) {
      throw new Error('Endpoint not found.');
    }
    return cloneDeep(NgFluxonosUtils.urlBuilder(environment)(path.join('.'), ...params));
  }

  protected getSearchParam(searchRequest: SearchRequestDto):
    | HttpParams
    | {
        [param: string]: string | string[];
      } {
    const params:
      | HttpParams
      | {
          [param: string]: string | string[];
        } = {};

    if (searchRequest.search) {
      params['search'] = `${encodeURIComponent(searchRequest.search)}`;
    }
    if (searchRequest.page) {
      params['page'] = `${searchRequest.page}`;
    }
    if (searchRequest.limit) {
      params['limit'] = `${searchRequest.limit}`;
    }
    if (searchRequest.orderBy) {
      params['orderBy'] = `${searchRequest.orderBy}`;
    }
    if (searchRequest.order) {
      params['order'] = `${searchRequest.order}`;
    }
    return params;
  }

  protected buildHttpParams(dtoInstance: any): HttpParams | { [param: string]: string | string[] } {
    const dto = instanceToPlain(dtoInstance);
    let params = new HttpParams();

    for (const key in dto) {
      if (dto.hasOwnProperty(key)) {
        const value = dto[key];
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params = params.append(key, `${item}`);
          });
        } else {
          params = params.set(key, `${value}`);
        }
      }
    }

    return params;
  }

  public abstract cleanUp(): void;
}
